module.exports = __webpack_public_path__ + "img/audio.6e32bb8.jpg";